class BasicCountdown extends HTMLElement {
  constructor() {
    super();
    this.interval = null;
  }

  connectedCallback() {
    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  get endDate() {
    return this.getAttribute('end-date');
  }

  getTimeUnits(distance) {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    
    return {
      days: days < 10 ? '0' + days : days.toString(),
      hours: hours < 10 ? '0' + hours : hours.toString(),
      minutes: minutes < 10 ? '0' + minutes : minutes.toString(),
      seconds: seconds < 10 ? '0' + seconds : seconds.toString()
    };
  }

  updateCountdown() {
    if (!this.endDate) return;
    
    const now = new Date().getTime();
    const endTime = new Date(this.endDate + ' UTC').getTime();
    const distance = endTime - now;

    if (distance < 0) {
      this.handleExpired();
      return;
    }

    const timeUnits = this.getTimeUnits(distance);
    this.updateDisplay(timeUnits);
  }

  updateDisplay(timeUnits) {
    for (const unit of ['days', 'hours', 'minutes', 'seconds']) {
      const element = this.querySelector(`[data-unit="${unit}"]`);
      if (element) {
        element.textContent = timeUnits[unit];
      }
    }
  }

  handleExpired() {
    if (this.interval) {
      clearInterval(this.interval);
    }
    this.innerHTML = '<div class="basic-countdown__expired">Countdown Expired</div>';
  }

  startCountdown() {
    this.updateCountdown();
    this.interval = setInterval(() => this.updateCountdown(), 1000);
  }
}

customElements.define('basic-countdown', BasicCountdown);